import { render, staticRenderFns } from "./priceSearchDetail.vue?vue&type=template&id=70abc8d6&scoped=true&"
import script from "./priceSearchDetail.vue?vue&type=script&lang=js&"
export * from "./priceSearchDetail.vue?vue&type=script&lang=js&"
import style0 from "./priceSearchDetail.vue?vue&type=style&index=0&id=70abc8d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70abc8d6",
  null
  
)

export default component.exports